import { ID_PARAM } from "./route-variables.constants";
export const CONNEXION = "connexion";
export const PREMIERE_CONNEXION = "premiere-connexion";
export const MOT_DE_PASSE_OUBLIE = "mot-de-passe-oublie";
export const AUTHENTIFICATION_FORTE = "authentification-forte";
export const REDIRECTION_UTILISATEUR = "redirection-utilisateur";
export const MENTIONS_LEGALES = "mentions-legales";
export const CONDITIONS_GENERALES = "conditions-generales";
export const ACCUEIL = "accueil";
export const PAGE_NON_TROUVEE = "page-non-trouvee";
export const AUTHENTICATION = "authentication";
export const LOGIN = "login";
export const REFRESH = "refresh";
export const MON_PROFIL = "mon-profil";
export const NOUS_CONTACTER = "nous-contacter";
export const NOS_OFFRES = "nos-offres";
export const REINITIALISATION_MOT_DE_PASSE = "reinitialisation-mot-de-passe";
export const MAINTENANCE = "maintenance";
export const REGULARISATION_SCHEDULE = "regularisation";
export const PAYMENT_REQUEST = "demande-paiement-avance";
export const QUOTATION = "devis";
export const DETAILS = "details";
export const QUOTATIONDETAILS = `devis/${ID_PARAM}/details`;
export const CONTRACTDETAILS = `contrat/${ID_PARAM}/details`;
export const CONTRACTDETAILS_PARTNER = `detail-contrat/${ID_PARAM}/:branch`;
export const CONTRACTDETAILS_PARTNER_WITHOUT_BRAND = `detail-contrat/${ID_PARAM}`;
export const RECEIPTSDETAIL = `contrat/${ID_PARAM}/details/receipts`;
export const STORED_DOCUMENTS = `contrat/${ID_PARAM}/stockage`;
export const REGULARISATION_OFF = "regularisation-off";
export const REGULARISATION_ON = "regularisation-on";
export const BASE_URL = "/";
